import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { LeftGrid } from '../../../../Episode/Episode.Styled';
import Typography from '@mui/material/Typography';
import {
  //GridSection,
  DialogHeader,
  DialogHeading,
} from '../../../Episode.Styled';
import styled from '@mui/system/styled';
import { useSelector } from 'react-redux';

const PrintActivities = (props) => {
  const { open, setOpen, episode, activities } = props;
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
//console.log('### episode')
//console.log(episode)
  const TableItem = styled('div')(({ theme }) => ({
    backgroundColor: '#F5F5F5',
    border: '1px solid',
    borderColor: theme.palette.mode === 'dark' ? '#444d58' : '#ced7e0',
    padding: theme.spacing(.5),
    borderRadius: '4px',
    textAlign: 'center',
  }));

  const participantInfo = useSelector((state) => state?.participants?.participantsDetail);
  //console.log('### participantInfo');
  //console.log(participantInfo);

  const STOP_REGION = process.env.REACT_APP_STOP_REGION;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      <DialogHeader>
        <DialogHeading variant='h5'></DialogHeading>
        <Box>
          <LeftGrid item xs={6}>
            <Button
              variant='contained'
              style={{ justifyContent: 'flex-end' }}
              onClick={() => handlePrint()}
            >
              Print
            </Button>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </LeftGrid>
        </Box>
      </DialogHeader>
      <Grid container ref={componentRef} px={2} mt={3}>
        <Grid item xs={12}>  
          <Box sx={{ justifyContent: 'center' }}>
            <Typography sx={{ textAlign: 'center' }} variant="h4" >
              Westcare of California STOP Area {STOP_REGION === '3' ? 'III' : 'I'}
            </Typography>
            <Typography sx={{ textAlign: 'center' }} variant="h5" fontWeight="800">
              Case Note(s)
            </Typography>
            <Typography sx={{ textAlign: 'center' }} variant="h6" >
              Episode: {episode.episodeId}
            </Typography>
          </Box>
        </Grid>
        
        <Grid container pt={3}>
          <Grid xs={4}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                Name
              </Typography>
            </TableItem>
          </Grid>
          <Grid xs={1}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                PrtID
              </Typography>
            </TableItem>
          </Grid>
          <Grid xs={1}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                CDC#
              </Typography>
            </TableItem>
          </Grid>
          <Grid xs={2}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                Referral SAP
              </Typography>
            </TableItem>
          </Grid>
          <Grid xs={2}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                Funding SAP
              </Typography>
            </TableItem>
          </Grid>
          <Grid xs={2}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                Release Date
              </Typography>
            </TableItem>
          </Grid>
        </Grid>

        <Grid container>
          <Grid xs={4}>
            <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
              {participantInfo[0].key}
            </Typography>
          </Grid>
          <Grid xs={1}>
            <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
              {participantInfo[0].id}
            </Typography>
          </Grid>
          <Grid xs={1}>
            <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
              {episode.cdc ? episode.cdc : episode.cDCNumber}
            </Typography>
          </Grid>
          <Grid xs={2}>
            <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
              {episode.referralSource}
            </Typography>
          </Grid>
          <Grid xs={2}>
            <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
              Westcare SASCA
            </Typography>
          </Grid>
          <Grid xs={2}>
            <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
              {episode.prisonRelease}
            </Typography>
          </Grid>
        </Grid> 

        <Grid container pt={5}>
          <Grid xs={2}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                Contact Date
              </Typography>
            </TableItem>
          </Grid>
          <Grid xs={3}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                Contact Type
              </Typography>
            </TableItem>
          </Grid>
          <Grid xs={3}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                Contact With
              </Typography>
            </TableItem>
          </Grid>
          <Grid xs={4}>
            <TableItem>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                Contact By
              </Typography>
            </TableItem>
          </Grid>
        </Grid>

        {activities.map((a, index) => (          
          <Grid key={index} container pb={4}>
            <Grid xs={2}>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                {a.dateCompleted}
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                {a.activityType}
              </Typography>
            </Grid>
            <Grid xs={3}>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                {a.activityWithContactName}
              </Typography>
            </Grid>
            <Grid xs={4}>
              <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                {a.activityByWestCareEmployee}
              </Typography>
            </Grid>
            <Grid xs={12}>
              <Typography sx={{ textAlign: 'left' }} variant="h6" >
                <div style={{whiteSpace: "pre-wrap"}}>{a.actNote}</div>
              </Typography>
            </Grid>
          </Grid>
        ))}

        <Typography sx={{ textAlign: 'left' }} mt={5} >
          Case Manager Name:____________________&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Case Manager Signature:____________________
        </Typography>

      </Grid>  
    </Dialog>  
  );
}

export default PrintActivities  